import styled from 'styled-components';

const SectionTitle = styled.h3`
  color: ${({ theme }) => theme.colors.brand || 'rgba(130, 22, 146, 1)'};
  font-size: ${({ theme }) => theme.fontSizes.large || '1.5rem'};
  font-weight: bold;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile || '768px'}) {
    font-size: ${({ theme }) => theme.fontSizes.medium || '1.2rem'};
  }
`;

export default SectionTitle;
